import Model from "../../Model";
//import { actions } from '@/store';

class Users extends Model{

    buildUrl ({ param }) {
        return ['users', param];
    }
}


export default new Users;